import { actionDuckUtils } from 'wanderu-ducks-utils';

import sliceNamespace from '../../types';

const namespace = 'ACTIONS/FETCH_C2C_DATA';

const {
    actions,
    reducer,
    selectors,
} = actionDuckUtils.buildBaseDuck(namespace, sliceNamespace);

export {
    actions,
    namespace,
    reducer,
    selectors,
};
